import React from 'react';

/**
 *
 * Scroll Fade In component
 * @extends {React.Component}
 */
interface IProps {
  text?: string;
  backgroundColor?:string;
  color?:string;
  outline?:string;
  ignoreAnimation?:any;
  href?:string;
  target?:string;
  className?:string;
}

class Button extends React.Component<IProps>{

  constructor(props: IProps) {
    super(props);
  }
  public render(): JSX.Element {
    let styles = {};
    let classList = "base-button";
    if(this.props.className){
      classList = classList+" "+this.props.className
    }
    let text = "";
    if(this.props.text){
      text = this.props.text;
    }
    if(this.props.backgroundColor){
      styles['backgroundColor'] = this.props.backgroundColor;
    } else{
      classList = classList+" primary-color-background white";
    }
    if(this.props.color){
      styles['color'] = this.props.color;
    }
    if(this.props.outline){
      classList = classList+" outline";
    }
    if(!this.props.ignoreAnimation){
      classList = classList+" animated";
    }
    let button = <div className={classList} style={styles}>{text}</div>;
    return (
     this.props.href ?
      <a href={this.props.href} target={this.props.target ? this.props.target : ""}>{button}</a>
      :
      button
    );
 }
}

 export default Button;
